import type { MailboxInfo } from 'owa-client-types';
import { LicenseType } from 'owa-copilot-settings-store/lib/services/types/serviceSettingTypes';
import copilotSettingsStore from 'owa-copilot-settings-store/lib/store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import hasM365CopilotLicense from './hasM365CopilotLicense';

export function isProdigiUser(mailboxInfo: MailboxInfo): boolean {
    if (!isFeatureEnabled('mon-copilot-prodigi', mailboxInfo)) {
        return false;
    }

    const store = copilotSettingsStore(mailboxInfo);
    if (store.isEnabled) {
        return (
            store.licenses.some(license => license === LicenseType.M365ConsumerCredits) &&
            !hasM365CopilotLicense(mailboxInfo)
        );
    }

    return false;
}
